<template>
  <div>
    <AppLoading :loading="loadingBusca">
    </AppLoading>
    <AppFormCabecalho titulo="Estudos na Lixeira" icon="mdi mdi-delete" />
    <div class="row align-items-center">
      <div class="col col-lg-6">
        <b-form-select
            size="sm"
            class="col-1"
            :options="[
              { value: 25, text: '25' },
              { value: 50, text: '50' },
              { value: 100, text: '100' }
            ]"
            required
            v-model="filtrar.maximoPorPagina"
        ></b-form-select
        >&nbsp;resultados por página
      </div>
      <div class="col col-lg-6">
        <div class="d-flex align-items-center justify-content-end">
          <b-dropdown
              text="Colunas"
              size="sm"
              variant="outline-secondary"
              class="m-2"
          >
            <a
                class="dropdown-item"
                v-for="(c, idx) in columnsSelect"
                :key="idx"
                href="javascript:void(0)"
                @click.stop="esconderColuna(c)"
            >
              <div class="custom-control custom-checkbox">
                <label class="custom-control-label column-select" :class="{'selected': c.show}">
                  {{ c.title }}
                </label>
              </div>
            </a>
          </b-dropdown>
          <b-dropdown
              text="Ações"
              size="sm"
              variant="outline-secondary"
              class="mr-2"
              :disabled="acoesDisabled"
          >
            <b-dropdown-item
                href="javascript:void(0)"
                :disabled="acoesDisabled"
                @click="removerEstudosSelecionados"
            >Deletar Estudos ({{ totalEstudosSelecionados }})</b-dropdown-item
            >
            <b-dropdown-item
                href="javascript:void(0)"
                :disabled="acoesDisabled"
                @click="recuperarEstudo"
            >Recuperar Estudos ({{
                totalEstudosSelecionados
              }})</b-dropdown-item
            >
          </b-dropdown>
          <div class="w-50">
            <b-form-input
                type="text"
                id="filtrarNome"
                placeholder="Filtrar pelo Paciente ou Paciente ID"
                v-model="filtrar.nome"
                size="sm"
                autocomplete="off"
            ></b-form-input>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table
          class="estudoTable table table-hover table-bordered table-sm mb-0 nowrap dataTable no-footer border-top-0"
      >
        <thead>
        <tr>
          <th
              v-for="(c, idx) in columns"
              :key="idx"
              :width="c.width"
              :class="c.class"
              @click="sort(c)"
              v-show="c.show"
          >
            {{ c.title }}
          </th>
          <th width="100px" class="text-right" style="padding-right: 14px;">
            <div
                class="selecionarTodos"
                title="Selecionar Todos"
                @click="selecionarTodosEstudos"
            >
              <i
                  class="mdi"
                  :class="{
                      'mdi-checkbox-blank-outline': !selecionarTodos,
                      'mdi-checkbox-marked': selecionarTodos
                    }"
              ></i>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(estudo, idx) in estudosFiltrados">
          <tr :key="idx">
            <td v-show="showColumn['nomePaciente']">
              {{ estudo.nomePaciente }}
              <div
                  class="text-sm text-muted estudoTable__uid"
                  title="Estudo Instancia UID"
              >
                {{ estudo.estudoInstanciaUID }}
              </div>
            </td>
            <td v-show="showColumn['descricao']">{{ estudo.descricao }}</td>
            <td v-show="showColumn['totalSerie']">{{ estudo.totalSerie + "/" + estudo.totalImagem }}</td>
            <td v-show="showColumn['dataNascimento']" class="text-center">{{ estudo.dataNascimento }}</td>
            <td v-show="showColumn['sexo']" class="text-center">{{ estudo.sexo }}</td>
            <td v-show="showColumn['pacienteID']">{{ estudo.pacienteID }}</td>
            <td v-show="showColumn['dataHoraEstudo']" class="text-center">{{ estudo.dataHoraEstudo }}</td>
            <td v-show="showColumn['modalidade']">{{ estudo.modalidades }}</td>
            <td v-show="showColumn['dataRemocao']">{{ estudo.dataRemocao }}</td>
            <td v-show="showColumn['numeroAcesso']">{{ estudo.numeroAcesso }}</td>
            <td class="text-center">
              <b-button-group size="sm">
                <b-button
                    variant="outline-secondary"
                    title="Recuperar Estudo"
                    @click="recuperarEstudo(estudo)"
                >
                  <i class="mdi mdi-undo"></i>
                </b-button>
                <b-button
                    variant="outline-secondary"
                    title="Apagar Estudo"
                    @click="deletarEstudo(estudo)"
                    :disabled="estudo.loadingRemover"
                >
                  <i
                      class="mdi text-danger"
                      :class="{
                          'mdi-delete': !estudo.loadingRemover,
                          'mdi-spin mdi-loading': estudo.loadingRemover
                        }"
                  ></i>
                </b-button>
                <b-button
                    variant="outline-secondary"
                    title="Selecionar"
                    @click="selecionarEstudo(estudo)"
                >
                  <i
                      class="mdi"
                      :class="{
                          'mdi-checkbox-blank-outline': !estudo.selecionado,
                          'mdi-checkbox-marked': estudo.selecionado
                        }"
                  ></i>
                </b-button>
              </b-button-group>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-6">
        <p class="text-muted">
          Total de estudos: {{ totalEstudos }}
        </p>
      </div>
      <div class="col-6">
        <b-pagination
            align="right"
            :total-rows="totalEstudos"
            v-model="filtrar.paginaAtual"
            :per-page="filtrar.maximoPorPagina"
        ></b-pagination>
      </div>
    </div>
    <ProgressoModal
        v-model="modalProgresso"
        :progresso="progressoValor"
    />
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import EstudoApi from "../../api/estudoApi";

import AppFormCabecalho from "../layout/AppFormCabecalho.vue";
import AppLoading from "../util/AppLoading.vue";
import ProgressoModal from "./ProgressoModal";
import Vue from "vue";

export default {
  name: "lixeiraTable",
  components: {
    ProgressoModal,
    AppFormCabecalho,
    AppLoading,
  },
  props: {
    estudos: Array,
    loadingBusca: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editar: false,
      filtrar: {
        maximoPorPagina: 25,
        nome: "",
        paginaAtual: 1,
        sort: "nomePaciente",
        order: "asc",
        lastColumn: null,
        dateFilter: false
      },
      processando: false,
      modalProgresso: false,
      progressoValor: 0,
      columns: [
        { title: "Paciente", name: "nomePaciente", class: "sorting", show: true },
        { title: "Descrição", name: "descricao", class: "sorting", show: true },
        { title: "S/I", name: "totalSerie", sorting: false, show: true },
        {
          title: "Data de Nascimento",
          name: "dataNascimento",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY", show: true
        },
        { title: "Sexo", name: "sexo", class: "sorting text-center", show: true },
        { title: "Paciente ID", name: "pacienteID", class: "sorting", show: true },
        {
          title: "Data do Estudo",
          name: "dataHoraEstudo",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY HH:mm:ss", show: true
        },
        { title: "Modalidade", name: "modalidade", class: "sorting", show: true },
        {
          title: "Data Remoção",
          name: "dataRemocao",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY HH:mm:ss",
          show: true
        },
        { title: "N\xFAm. Acesso", name: "numeroAcesso", class: "sorting", show: true }
      ],
      mostrar: false,
      tags: [
        { label: "Paciente ID", val: "pacienteID", edit: false },
        { label: "Descrição Estudo", val: "descriacaoEstudo", edit: false },
        { label: "Nome Paciente", val: "nomePaciente", edit: false },
        { label: "Núm. Acesso", val: "numeroAcesso", edit: false },
        { label: "Data Nascimento", val: "dataNascimento", edit: false },
        { label: "Data Estudo", val: "dataEstudo", edit: false },
        { label: "Data Aquisição", val: "dataAquisicao", edit: false }
      ],
      estudo: {
        pacienteID: "",
        descriacaoEstudo: "",
        nomePaciente: "",
        numeroAcesso: "",
        dataNascimento: "",
        dataEstudo: "",
        dataAquisicao: ""
      },
      selecionarTodos: false,
      showColumn: {
        'nomePaciente': true, 'descricao': true, 'totalSerie': true, 'dataNascimento': true, 'sexo': true,
        'pacienteID': true, 'dataHoraEstudo': true, 'modalidade': true, 'dataRemocao': true, 'numeroAcesso': true
      }
    };
  },
  computed: {
    estudosFiltrados() {
      let estudos = this.estudos;
      return estudos
          .sort((a, b) => {
            let modifier = 1;
            if (this.filtrar.order === "desc") modifier = -1;
            if (this.filtrar.dateFilter) {
              const dateA = moment(a[this.filtrar.sort], this.filtrar.dateFilter);
              const dateB = moment(b[this.filtrar.sort], this.filtrar.dateFilter);
              if (dateA.isBefore(dateB)) return -1 * modifier;
              if (dateA.isAfter(dateB)) return 1 * modifier;
            } else {
              if (a[this.filtrar.sort] < b[this.filtrar.sort])
                return -1 * modifier;
              if (a[this.filtrar.sort] > b[this.filtrar.sort])
                return 1 * modifier;
            }
            return 0;
          })
          .filter(row => {
            if (this.filtrar.nome == "") return true;
            let q = _.deburr(this.filtrar.nome).toLowerCase();
            let nomePaciente = _.deburr(row.nomePaciente).toLowerCase();
            let pacienteID = _.deburr(row.pacienteID).toLowerCase();
            return nomePaciente.indexOf(q) >= 0 || pacienteID.indexOf(q) >= 0;
          })
          .filter((row, idx) => {
            let start =
                (this.filtrar.paginaAtual - 1) * this.filtrar.maximoPorPagina;
            let end = this.filtrar.paginaAtual * this.filtrar.maximoPorPagina;
            if (idx >= start && idx < end) return true;
          });
    },
    totalEstudos() {
      return this.estudos.length;
    },
    columnsSelect() {
      return this.columns.filter(c => c.name !== "");
    },
    totalColumnsSelected() {
      return this.columnsSelect.filter(c => c.show).length;
    },
    totalEstudosSelecionados() {
      return this.estudosSelecionados.length;
    },
    estudosSelecionados() {
      return this.estudos.filter(row => {
        return row.selecionado;
      });
    },
    acoesDisabled() {
      return this.removerEstudosDisabled;
    },
    removerEstudosDisabled(){
      return this.totalEstudosSelecionados === 0;
    }
  },
  methods: {
    sort(s) {
      if (s.sorting == false) return;
      const regexSorting = /sorting(_asc)|sorting(_desc)/gm;
      if (this.filtrar.lastColumn !== null)
        this.filtrar.lastColumn.class = this.filtrar.lastColumn.class.replace(
            regexSorting,
            "sorting"
        );
      //if s == current sort, reverse
      if (s.name === this.filtrar.sort) {
        this.filtrar.order = this.filtrar.order === "asc" ? "desc" : "asc";
      }

      const regexSorting2 = /^sorting\s{0,1}|sorting_asc\s{0,1}|sorting_desc\s{0,1}/gm;
      s.class = `sorting_${this.filtrar.order} ${s.class.replace(
          regexSorting2,
          ""
      )}`;
      this.filtrar.sort = s.name;
      this.filtrar.lastColumn = s;
      this.filtrar.dateFilter = s.dateFilter;
    },
    deletarEstudo(estudo) {
      this.$swal({
        title: "Deseja remover o estudo da lixeira?",
        html: "Esta operação não poderá ser revertida!",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-outline-danger",
        cancelButtonClass: "btn btn-success mr-3",
        buttonsStyling: false,
        confirmButtonText: "Sim, remover estudo!",
        cancelButtonText: "Não, cancelar remoção!",
        reverseButtons: true,
        focusCancel: true,
        focusConfirm: false
      }).then(resp => {
        if (resp.value) {
          this.$set(estudo, "loadingRemover", true);
          EstudoApi.removerDaLixeira(
              estudo.servidorId,
              estudo.estudoInstanciaUID
          ).then(() => {
            const idx = this.estudos.indexOf(estudo);
            this.estudos.splice(idx, 1);
            this.$set(estudo, "loadingRemover", false);
          })
              .catch(e => {
                console.log(e);
                this.$set(estudo, "loadingRemover", false);
              });
        }
      });
    },
    esconderColuna(coluna) {
      if (this.totalColumnsSelected === 1 && !!coluna.show) return;
      coluna.show = !coluna.show;
      this.showColumn[coluna.name] = coluna.show;
      this._saveColumnsConfig();
    },
    selecionarEstudo(estudo) {
      this.$set(estudo, "selecionado", !estudo.selecionado);
    },
    selecionarTodosEstudos() {
      this.selecionarTodos = !this.selecionarTodos;
      this.estudosFiltrados.forEach(estudo => {
        this.$set(estudo, "selecionado", this.selecionarTodos);
      });
    },
    removerEstudosSelecionados() {
      //Caso so um selecionado, utilizar funcao padrao
      if (this.totalEstudosSelecionados === 1) {
        this.deletarEstudo(this.estudosSelecionados[0]);
        return;
      }

      this._removerVarios(
          "estudo",
          this.estudosSelecionados[0].servidorGrupoNome,
          async () => {
            this.modalProgresso = true;
            this.progressoValor = 0;

            let promises = [];
            for (let i = 0; i < this.totalEstudosSelecionados; i++) {
              const estudo = this.estudosSelecionados[i];
              promises.push(
                  EstudoApi.removerDaLixeira(
                      estudo.servidorId,
                      estudo.estudoInstanciaUID,
                      false
                  )
              );
            }
            let pos = 1;
            try {
              await promises.reduce(
                  async (previousPromise, nextAsyncFunction) => {
                    await previousPromise;
                    await nextAsyncFunction;
                    let perc = Math.ceil(
                        (pos * 100) / this.totalEstudosSelecionados
                    );
                    this.progressoValor = perc;
                    pos++;
                  },
                  Promise.resolve()
              );

              _.each(this.estudosSelecionados, estudo => {
                const idx = this.estudos.indexOf(estudo);
                this.estudos.splice(idx, 1);
              });
              this.modalProgresso = false;
            } catch (e) {
              this.modalProgresso = false;
              this.progressoValor = 100;
              console.log(e);
              Vue.notify({
                group: "geral",
                type: "error",
                title: "Ops!",
                text: "Ocorreu um erro ao remover os estudos."
              });
            }
          }
      );
    },
    async recuperarEstudo(estudo){
      this.$notify({
        group: "geral",
        type: "info",
        title: "Processo iniciado!",
        text: "O processo para recuperar o estudo foi inicializado."
      });
      if(estudo && estudo.estudoInstanciaUID){
        this.estudosSelecionados.push(estudo);
      }
      await this._recuperarVarios();
    },
    _saveColumnsConfig(){
      localStorage.setItem("colConfig", JSON.stringify(this.showColumn));
    },
    _getColumnsConfig(){
      let config = localStorage.getItem("colConfig");
      if(!config || config === "") return;
      this.showColumn = JSON.parse(config);
      for(const name in this.showColumn){
        let column = this.columns.find(c => c.name === name);
        if(column) column.show = this.showColumn[name];
      }
    },
    async _recuperarVarios(){
      this.progressoValor = 0;

      let promises = [];
      this.estudosSelecionados.forEach(estudo => {
        promises.push(EstudoApi.recuperarEstudoLixeira(
            estudo.servidorId,
            estudo.estudoInstanciaUID,
            false
        ).then(()=>{
          const idx = this.estudos.indexOf(estudo);
          this.estudos.splice(idx, 1);
        }));
      });

      let pos = 1;
      try {
        await promises.reduce(async (previousPromise, nextAsyncFunction) => {
          await previousPromise;
          await nextAsyncFunction;
          let perc = Math.ceil((pos * 100) / this.totalEstudosSelecionados);
          this.progressoValor = perc;
          pos++;
        }, Promise.resolve());

        this.$notify({
          group: "geral",
          type: "success",
          title: "Estudo recuperado!",
          text: "O estudo foi recuperado da lixeira com sucesso."
        });
      } catch (e) {
        this.progressoValor = 100;
        console.log(e);
        this.$notify({
          group: "geral",
          type: "error",
          title: "Ops!",
          text: "Ocorreu um erro ao recuperar os estudos."
        });
      }
    },
    _removerVarios(tipo, servidorGrupoNome, fn) {
      this.$swal({
        title: `Deseja remover os Estudos permanentemente?`,
        html: `Esta operação não poderá ser revertida!<br/>Total selecionado: <strong>${this.totalEstudosSelecionados}</strong>`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-outline-danger",
        cancelButtonClass: "btn btn-success mr-3",
        buttonsStyling: false,
        confirmButtonText: `Sim, remover estudos!`,
        cancelButtonText: "Não, cancelar remoção!",
        reverseButtons: true,
        focusCancel: true,
        focusConfirm: false
      }).then(async resp => {
        if (resp.value) {
          fn();
        }
      });
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      value = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    this._getColumnsConfig();
  }
};
</script>
<style lang="scss" scoped>
.editarDicom {
  position: fixed;
  width: 50%;
  top: 41px;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1041;
  border-left: 1px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  flex: 0;
  .wbs-form-header {
    padding: 10px 10px 0 10px;
  }
  @include element("conteudo") {
    padding: 10px;
    flex: 1;
  }
  @include element("footer") {
    padding: 10px;
    flex: 0;
    border-top: 1px solid #e3e3e3;
  }
}
.editarDicom__backdrop {
  opacity: 0.5;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.estudoTable {
  border: 1px solid #dee2e6;
  .estudoTable__uid {
    font-size: 0.7rem;
  }
}
.estudoTable__line-v {
  position: relative;
  &:after {
    content: "";
    border: 1px solid;
    top: 0;
    bottom: 0;
    position: absolute;
    left: 49%;
    color: #829ab1;
  }
}
.estudoTable__line-h {
  position: relative;
  &:after {
    content: "";
    border: 1px solid;
    top: 49%;
    left: -28px;
    position: absolute;
    width: 28px;
    color: #829ab1;
  }
}
.selecionarTodos {
  cursor: pointer;
  display: inline-block;
  &:hover {
    color: #555758;
  }
}
.column-select{
  &.selected::after{
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
  }

  &.selected::before{
    background-color: #3D9970;
  }
}
</style>